import React from "react";
import Paper from "@mui/material/Paper";
import { makeStyles } from "tss-react/mui";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";

const useStyles = makeStyles()((theme) => ({
  TableHead: {
    "& .MuiTableCell-root": {
      color: "#A2A2A2",
    },
  },
  TableBody: {
    "& .MuiOutlinedInput-input": {
      padding: "4px 10px",
    },
  },
  TableRow: {
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
      // padding: "0px 10px",
    },
    "& .MuiTableCell-root": {
      border: "none",
    },
    "& .MuiTableCell-root:last-child": {
      padding: "10px 0px",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "24px",
    },
  },
  IconHolder: {
    borderRadius: "50px",
    margin: "0",
    padding: "5px 5px",
    fontSize: "19px",
    "&.Mui-disabled": {
      color: "#00000042 !important",
    },
  },
}));

const SimpleTable = ({ configData }) => {
  const {
    tableMaxHeight,
    columns,
    tableData,
    textMaxLength,
    handleTextChange,
    handleEditClick,
    handleDeleteClick,
    noDataColspan,
    noDataMessage,
    rowHover = false,
  } = configData;

  const { classes } = useStyles();

  return (
    <TableContainer component={Paper} sx={(tableMaxHeight ? { maxHeight: tableMaxHeight } : "", { flexGrow: 1 })}>
      <Table sx={{ minWidth: 350, borderCollapse: "collapse" }} aria-label="simple table" size="small">
        <TableHead className={classes.TableHead}>
          <TableRow>
            {columns.map((header, index) => (
              <TableCell
                key={index}
                sx={header.width ? { width: header.width } : ""}
                align={header.align || "inherit"}
                style={header.style}
              >
                {header.name}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody className={classes.TableBody}>
          {tableData.length ? (
            tableData.map((row, key) => (
              <TableRow hover={rowHover} key={key} className={classes.TableRow}>
                {row.map((cell, index) => (
                  <TableCell component="th" key={index} scope="row" align={cell.align || "inherit"} style={cell.style}>
                    {cell.editable ? (
                      <TextField
                        inputProps={textMaxLength ? { maxLength: textMaxLength } : ""}
                        value={cell.value || ""}
                        sx={cell.textWidth ? { width: cell.textWidth } : ""}
                        name={`${columns[index].name}[]`}
                        onChange={(e) => handleTextChange(e, key, index)}
                      />
                    ) : cell.value ? (
                      cell.value
                    ) : cell.editIcon && cell.deleteIcon ? (
                      <>
                        <IconButton
                          className={classes.IconHolder}
                          color="error"
                          onClick={() => handleEditClick(key)}
                          disabled={cell.disabled}
                        >
                          {cell.editIcon}
                        </IconButton>
                        <IconButton
                          className={classes.IconHolder}
                          style={{ marginLeft: "5px" }}
                          color="error"
                          onClick={() => handleDeleteClick(key)}
                          disabled={cell.disabled}
                        >
                          {cell.deleteIcon}
                        </IconButton>
                      </>
                    ) : (
                      (cell.editIcon ? (
                        <IconButton
                          className={classes.IconHolder}
                          color="error"
                          onClick={() => handleEditClick(key)}
                          disabled={cell.disabled}
                        >
                          {cell.editIcon}
                        </IconButton>
                      ) : (
                        ""
                      ),
                      cell.deleteIcon ? (
                        <IconButton
                          className={classes.IconHolder}
                          style={{ marginLeft: "5px" }}
                          color="error"
                          onClick={() => handleDeleteClick(key)}
                          disabled={cell.disabled}
                        >
                          {cell.deleteIcon}
                        </IconButton>
                      ) : (
                        ""
                      ))
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow className={classes.TableRow}>
              <TableCell colSpan={noDataColspan} component="td" scope="row" align={"center"}>
                {noDataMessage || "No data available"}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SimpleTable;
